import React, { useState } from 'react'

function useLocalStorage(itemName, initialValue) {
    const [item, setItem] = useState(initialValue);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            try {
                let parsedItem;
                if (!localStorage.getItem(itemName)) {
                    localStorage.setItem(itemName, JSON.stringify(initialValue));
                    parsedItem = initialValue;
                } else {
                    parsedItem = JSON.parse(localStorage.getItem(itemName));
                }
                setLoading(false);
                setItem(parsedItem);
            } catch (error) {
                setLoading(false);
                setError(true);
            }
        }, 10);
    })

    const saveItem = (newItem) => {
        localStorage.setItem(itemName, JSON.stringify(newItem))
        setItem(newItem)
    }

    return { item, saveItem, loading, error }
}

export { useLocalStorage }